import React from "react";

// One shared page frame for the v2 API-supported surface. Owns the ground
// background, the standard page padding and the width behaviour so individual
// pages stop re-inventing their own wrappers.
//   variant="list"   → full-bleed wide record lists (no max-width cap)
//   variant="capped" → 1080px centred column for Settings / editor experiences
export const PageShell = React.forwardRef(function PageShell(
  { variant = "list", className = "", innerClassName = "", style, innerStyle, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={`page-shell ${variant === "capped" ? "capped" : "list"} ${className}`.trim()}
      style={style}
      {...rest}
    >
      <div className={`page-shell-in ${innerClassName}`.trim()} style={innerStyle}>
        {children}
      </div>
    </div>
  );
});

export default PageShell;
